import React from 'react';
import { Paperclip } from 'lucide-react';

/**
 * Drag overlay shown when dragging files over the chat
 */
const ChatDragOverlay = () => {
  return (
    <div className="fixed inset-0 bg-purple-500/10 backdrop-blur-sm z-40 pointer-events-none flex items-center justify-center">
      <div className="bg-white border-2 border-dashed border-purple-400 rounded-2xl p-8 text-center">
        <Paperclip className="w-12 h-12 text-purple-600 mx-auto mb-3" />
        <p className="text-lg font-semibold text-purple-900">Slipp filen her</p>
        <p className="text-sm text-purple-600 mt-1">PDF, Word eller bilder</p>
      </div>
    </div>
  );
};

export default ChatDragOverlay;
